import get from "lodash/get";
import * as React from "react";
import { connect } from "react-redux";

import {
  getExchangesAction,
  getLedgerHead as getLedgerHeadAction,
  getRewardsAction,
  getShopifyVariants as getShopifyVariantsAction,
  setExchangeId,
  setScreenName,
} from "../../actions";
import {
  RedemptionOptions as RedemptionOptionsComponent,
  RedemptionOptionsProps,
} from "../../components/RedemptionOptions/RedemptionOptions";
import { StoreState } from "../../reducers";
import {
  getExchanges,
  getIsLoadingExchanges,
} from "../../reducers/exchange/methods";
import { getLedgerHead, getRewardRequestStatus } from "../../reducers/methods";
import { getRewards, getShopifyVariants } from "../../reducers/reward/methods";
import { customerAuthenticationOccurred } from "../../utils/customer";

interface RedemptionOptionsContainerProps extends RedemptionOptionsProps {
  currency?: string;
  getExchangesAction: typeof getExchangesAction;
  getLedgerHeadAction: typeof getLedgerHeadAction;
  getShopifyVariantsAction: typeof getShopifyVariantsAction;
  ledgerHead: ReturnType<typeof getLedgerHead>;
  redemptionOptions: ReturnType<typeof getExchanges>;
  requestStatus: ReturnType<typeof getRewardRequestStatus>;
  shopifyVariants: ReturnType<typeof getShopifyVariants>;
  getRewardsAction: typeof getRewardsAction;
  rewards: ReturnType<typeof getRewards>;
}

class RedemptionOptions extends React.Component<RedemptionOptionsContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      this.props.getExchangesAction();
      if (this.props.requestStatus.getLedger !== "REQUESTING") {
        this.props.getLedgerHeadAction({
          currency: this.props.currency || "loyalty",
        });
      }
    }
  }

  componentDidUpdate(prevProps: RedemptionOptionsContainerProps) {
    if (customerAuthenticationOccurred(prevProps.data, this.props.data)) {
      this.props.getExchangesAction();
      if (this.props.requestStatus.getLedger !== "REQUESTING") {
        this.props.getLedgerHeadAction({
          currency: this.props.currency || "loyalty",
        });
      }
    }
    if (
      prevProps.redemptionOptions !== this.props.redemptionOptions &&
      this.props.redemptionOptions &&
      this.props.redemptionOptions.length
    ) {
      const variantIds: string[] = [];
      this.props.redemptionOptions.forEach((exchangeOption) => {
        if (
          exchangeOption.reward &&
          exchangeOption.reward.rewardType === "shopifyFreeGift" &&
          exchangeOption.status === "active"
        ) {
          const freeGiftConfig = exchangeOption.reward.shopifyFreeGiftConfig;
          if (
            freeGiftConfig &&
            freeGiftConfig.productVariant &&
            freeGiftConfig.productVariant.id
          ) {
            variantIds.push(freeGiftConfig.productVariant.id);
          }
          if (
            freeGiftConfig &&
            freeGiftConfig.fallbackProductVariant &&
            freeGiftConfig.fallbackProductVariant.id
          ) {
            variantIds.push(freeGiftConfig.fallbackProductVariant.id);
          }
        }
      });
      const uniqueVariantIds = variantIds.filter(
        (id, index, arr) => arr.indexOf(id) === index
      );
      if (uniqueVariantIds.length > 0) {
        this.props.getShopifyVariantsAction(uniqueVariantIds);
      }
    }
  }

  render() {
    return <RedemptionOptionsComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  isLoading: getIsLoadingExchanges(state.exchange),
  ledgerHead: getLedgerHead(state),
  redemptionOptions: getExchanges(state.exchange),
  requestStatus: getRewardRequestStatus(state),
  shopifyVariants: getShopifyVariants(state.reward),
  rewards: getRewards(state.reward),
});

export default connect(mapStateToProp, {
  getExchangesAction,
  getLedgerHeadAction,
  setExchangeId,
  setScreenName,
  getShopifyVariantsAction,
  getRewardsAction,
})(RedemptionOptions);
